import React from 'react'
import Contactdetails from './Contactdetails'
import Contactheader from './Contactheader'

const Contact = () => {
  return (
    <div>
        <Contactheader/>
        <Contactdetails/>
    </div>
  )
}

export default Contact